import { render, staticRenderFns } from "./OnlineClassDictation.vue?vue&type=template&id=2998b83b&"
import script from "./OnlineClassDictation.vue?vue&type=script&lang=js&"
export * from "./OnlineClassDictation.vue?vue&type=script&lang=js&"
import style0 from "./OnlineClassDictation.vue?vue&type=style&index=0&id=2998b83b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports